module.exports = __webpack_public_path__ + "img/yanchong.59446bc3.png";